/**
 * Modelos disponíveis por provedor de IA. Usado pelos seletores em
 * Settings (multi-provider manager). Mantém em um lugar só pra não
 * duplicar entre componentes.
 */
export const AI_MODELS = {
    CLAUDE: [
        { value: 'claude-opus-4-7',           label: 'Claude Opus 4.7 (mais capaz)' },
        { value: 'claude-sonnet-4-6',         label: 'Claude Sonnet 4.6 (recomendado)' },
        { value: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5 (mais rápido)' },
    ],
    OPENAI: [
        { value: 'gpt-4o',       label: 'GPT-4o' },
        { value: 'gpt-4o-mini',  label: 'GPT-4o Mini (mais rápido)' },
        { value: 'gpt-4-turbo',  label: 'GPT-4 Turbo' },
        { value: 'o3-mini',      label: 'o3-mini (raciocínio)' },
    ],
    GROQ: [
        { value: 'llama-3.3-70b-versatile', label: 'Llama 3.3 70B (recomendado)' },
        { value: 'llama-3.1-8b-instant',    label: 'Llama 3.1 8B (mais rápido)' },
        { value: 'mixtral-8x7b-32768',      label: 'Mixtral 8x7B' },
    ],
    DEEPSEEK: [
        { value: 'deepseek-chat',     label: 'DeepSeek Chat (recomendado)' },
        { value: 'deepseek-reasoner', label: 'DeepSeek Reasoner (raciocínio)' },
    ],
    // Curado 24/07 pela lista REAL da chave grátis (AI Studio, projeto sem billing): o 2.5-flash
    // foi aposentado pra chaves novas e o 2.0-flash dá 429 — ambos saíram. Recomendado = o Flash-Lite
    // atual (barato/rápido, ideal pro sinal de alta frequência). Os 3.x cheios são THINKING e o
    // cliente (GeminiAi.js) já os trata — ficam como opção de mais qualidade pra análise/risco.
    GEMINI: [
        { value: 'gemini-3.1-flash-lite',  label: 'Gemini 3.1 Flash-Lite (recomendado, sinal)' },
        { value: 'gemini-3.6-flash',       label: 'Gemini 3.6 Flash (mais capaz — análise)' },
        { value: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro (máxima qualidade)' },
        { value: 'gemini-3.5-flash-lite',  label: 'Gemini 3.5 Flash-Lite (lite mais novo)' },
    ],
    MISTRAL: [
        { value: 'mistral-small-latest',  label: 'Mistral Small (mais rápido)' },
        { value: 'mistral-medium-latest', label: 'Mistral Medium' },
        { value: 'mistral-large-latest',  label: 'Mistral Large (recomendado)' },
    ],
    GROK: [
        { value: 'grok-2-latest', label: 'Grok 2 (recomendado)' },
        { value: 'grok-2-mini',   label: 'Grok 2 Mini (mais rápido)' },
    ],
    CEREBRAS: [
        { value: 'gpt-oss-120b', label: 'GPT-OSS 120B (recomendado, ~3000 tok/s)' },
        { value: 'zai-glm-4.7',  label: 'GLM 4.7 (preview)' },
    ],
    // OpenRouter ROTA os slugs :free com frequência — estes refletem o catálogo de 2026-06-28.
    // Se um sair, use "↻ Atualizar da API" pra ver os :free atuais. Ver project_backlog_new_ai_providers.
    OPENROUTER: [
        { value: 'openai/gpt-oss-120b:free',             label: 'GPT-OSS 120B (free, recomendado)' },
        { value: 'qwen/qwen3-next-80b-a3b-instruct:free', label: 'Qwen3 80B Instruct (free)' },
        { value: 'openai/gpt-oss-20b:free',              label: 'GPT-OSS 20B (free, rápido)' },
    ],
    SAMBANOVA: [
        { value: 'Meta-Llama-3.3-70B-Instruct',  label: 'Llama 3.3 70B (recomendado)' },
        { value: 'Llama-3.1-8B-Instruct',        label: 'Llama 3.1 8B (mais rápido)' },
        { value: 'DeepSeek-V3.1',                 label: 'DeepSeek V3.1' },
    ],
    ZHIPU: [
        { value: 'glm-4.5-flash', label: 'GLM 4.5 Flash (free, recomendado)' },
        { value: 'glm-4.6',       label: 'GLM 4.6 (mais capaz)' },
        { value: 'glm-4.5-air',   label: 'GLM 4.5 Air' },
    ],
    GITHUB: [
        { value: 'openai/gpt-4o-mini',            label: 'GPT-4o Mini (free, recomendado)' },
        { value: 'openai/gpt-4o',                 label: 'GPT-4o (mais capaz)' },
        { value: 'meta/Llama-3.3-70B-Instruct',   label: 'Llama 3.3 70B' },
        { value: 'mistral-ai/Mistral-Nemo',       label: 'Mistral Nemo (rápido)' },
    ],
};
